export const getHeadrestException = (state) => {
    if (state.backrest !== "Postural Backrest") {
        return "Only available with postural backrest.";
    }
    return null;
};
